import { render } from "./TestUsageChart.vue?vue&type=template&id=6ca39ba4&scoped=true"
import script from "./TestUsageChart.vue?vue&type=script&lang=js"
export * from "./TestUsageChart.vue?vue&type=script&lang=js"

import "./TestUsageChart.vue?vue&type=style&index=0&id=6ca39ba4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ca39ba4"]])

export default __exports__